import apiClient from "../apiClient";
import { apiNodeBaseUrl } from "../../config";

export const getTaxRegimeList = async () => {
    return apiClient.get(`${apiNodeBaseUrl}sat/regimes-list`, {})
    .then(response => { return response });
}